import { alpha, Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    wrapper: {
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        alignItems: 'center',
        borderRadius: '999em',
        background: colorsPalette.whiteSecondary,
        height: 54,
        paddingLeft: 25,
        paddingRight: 4,
        position: 'relative',
        flexBasis: '260px',
        marginLeft: MIDDLE_MARGIN,
      },
    },
    wrapperOpen: {
      position: 'relative',
      background: colorsPalette.whiteSecondary,
      borderRadius: '999em',
      height: 54,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 30,
      paddingRight: 4,

      [theme.breakpoints.up('sm')]: {
        maxWidth: 480,
        flexGrow: 1,
        minWidth: 300,
      },
    },
    searchPlaceholder: {
      whiteSpace: 'nowrap',
      position: 'relative',
      top: -2,
      flexGrow: 1,
      marginRight: SMALL_MARGIN,
      fontSize: 20,
      display: 'none',
      color: alpha(colorsPalette.white, 0.33),
      [theme.breakpoints.up('md')]: {
        display: 'block',
      },
    },
    closeIconWrapper: {
      position: 'absolute',
      left: -50,
      top: '50%',
      transform: 'translateY(-50%)',

      '& svg': {
        width: 20,
        height: 20,
      },
    },
    inputWrapper: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    searchIcon: {
      width: 24,
      height: 24,
    },
  });
});

export default useStyles;
